export class TransactionStatus {
    code: string
    description: string

    constructor(code: string, description: string) {
        this.code = code
        this.description = description
    }
}

export class Transaction {
    id: number 
    date: Date
    amount: number
    remarks: string
    source: string
    reference: string
    status: TransactionStatus
    bankreference: string

    constructor(id: number, date: Date, amount: number, remarks: string, source: string, reference: string, status: TransactionStatus, bankreference : string) {
        this.id = id        
        this.date = date
        this.amount = amount        
        this.remarks = remarks
        this.source = source
        this.reference = reference        
        this.status = status
        this.bankreference = bankreference
    }
}